// Copyright 2018 Sorama B.V.

import { UnitType } from "units/Unit";
import { CompositeUnit } from "./CompositeUnit";
import { Length } from "./Length";
import { Time } from "./Time";

export class Velocity extends UnitType {
    public static override typeName = "Velocity";

    public static meterPerSecond: CompositeUnit = new CompositeUnit(Length.meter, Time.second, Velocity);
    public static kilometerPerHour: CompositeUnit = new CompositeUnit(Length.kiloMeter, Time.hour, Velocity);
    public static milePerHour: CompositeUnit = new CompositeUnit(Length.mile, Time.hour, Velocity);
}
